module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};


//////////////////
// WEBPACK FOOTER
// /home/dani/kaiwa/~/core-js/library/modules/$.a-function.js
// module id = 493
// module chunks = 2